import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ThemeProvider } from "@/hooks/useTheme"
import { Toaster } from "@/components/ui/sonner"
import { RouteDocumentTitle } from "@/components/RouteDocumentTitle"
import { PortalDashboard } from "@/views/PortalDashboard"
import { PortalLogin } from "@/views/PortalLogin"
import { PortalInvoiceDetail } from "@/views/PortalInvoiceDetail"
import { PortalClientSelect } from "@/views/PortalClientSelect"
import { PortalVerify } from "@/views/PortalVerify"

const queryClient = new QueryClient()

export default function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <RouteDocumentTitle />
          <Routes>
            <Route path="/" element={<PortalLogin />} />
            <Route path="/verify" element={<PortalVerify />} />
            <Route path="/select" element={<PortalClientSelect />} />
            <Route path="/dashboard" element={<PortalDashboard />} />
            <Route path="/invoices/:id" element={<PortalInvoiceDetail />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  )
}
